import type { GatewayBrowserClient } from "../gateway";

export type NodesState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  nodesLoading: boolean;
  nodes: Array<Record<string, unknown>>;
  lastError: string | null;
};

export async function loadNodes(state: NodesState, opts?: { quiet?: boolean }) {
  if (!state.client || !state.connected) return;
  const quiet = Boolean(opts?.quiet);
  if (!quiet && state.nodesLoading) return;
  if (!quiet) state.nodesLoading = true;
  if (!quiet) state.lastError = null;
  try {
    const res = (await state.client.request("node.list", {})) as {
      nodes?: Array<Record<string, unknown>>;
    };
    const nextNodes = Array.isArray(res.nodes) ? res.nodes : [];
    if (nextNodes !== state.nodes) {
      state.nodes = nextNodes;
    }
  } catch (err) {
    if (!quiet) state.lastError = String(err);
  } finally {
    if (!quiet) state.nodesLoading = false;
  }
}
